import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'
import { HiMenu } from 'react-icons/hi'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { links } from './SidebarLinks'

const Sidebar = () => {
  const [isopen, setOpen] = useState(true)
  const [isMob, setIsMob] = useState(false)

  const { user } = useSelector((state) => state.auth)

  useEffect(() => {
    function toggleSideBar() {
      setOpen(window.innerWidth >= 850)
      setIsMob(window.innerWidth <= 425)
    }

    window.addEventListener('resize', toggleSideBar)
    return () => window.removeEventListener('resize', toggleSideBar)
  }, [])

  const toogleMenu = () => {
    setOpen(!isopen)
  }

  const navVariants = isMob
    ? {
        open: {
          position: 'absolute',
          width: '100%',
          x: 0,
        },
        closed: {
          position: 'absolute',
          width: '100%',
          x: '-100vw',
        },
      }
    : {
        open: {
          width: 225,
        },
        closed: {
          width: 80,
        },
      }

  return (
    <div>
      {isMob && (
        <div className='position-absolute' style={{ top: 24, left: 24 }}>
          <HiMenu onClick={toogleMenu} size={24} />
        </div>
      )}

      <motion.div
        initial='closed'
        animate={isopen ? 'open' : 'closed'}
        variants={navVariants}
        className='d-print-none dashboard-cards m-0 rounded-0 d-flex flex-column p-3 h-100'
      >
        <div
          className={`d-flex align-items-center mb-3 gap-2 py-1 px-2 ${
            !isopen ? 'justify-content-center' : ''
          }`}
          style={{ height: 36 }}
        >
          <HiMenu onClick={toogleMenu} size={24} />
          <span
            className='fs-5'
            style={{
              whiteSpace: 'nowrap',
              color: 'var(--primary-color)',
              display: isopen ? 'inline-block' : 'none',
            }}
          >
            NEMA AI
          </span>
        </div>

        <nav className='flex-grow-1 mb-3'>
          <ul className='list-unstyled d-flex flex-column gap-1 m-0'>
            {links.map((item, index) => {
              if (item.type === 'divider') {
                return <hr key={index} className='m-0 bg-secondary' />
              } else if (item.type === 'title') {
                return (
                  isopen && (
                    <p
                      key={index}
                      className='text-muted px-2 py-1 text-uppercase m-0 mt-1'
                      style={{ fontSize: 12 }}
                    >
                      {item.label}
                    </p>
                  )
                )
              } else if (item.type === 'link') {
                if (item.access && !item.access.includes(user?.id)) return null
                return (
                  <li key={index} onClick={() => isMob && setOpen(false)}>
                    <NavLink
                      to={item.link}
                      className={`m-0 py-1 px-2 d-flex align-items-center gap-2 ${
                        !isopen ? 'justify-content-center' : ''
                      }`}
                      style={({ isActive }) => {
                        return {
                          whiteSpace: 'nowrap',
                          borderRadius: 12,
                          background: isActive ? 'var(--primary-color)' : '',
                          color: isActive ? 'white' : '#111111',
                        }
                      }}
                    >
                      <span style={{ fontSize: 18 }}>{item.icon}</span>
                      <span
                        style={{
                          display: isopen ? 'block' : 'none',
                          fontSize: 14,
                        }}
                      >
                        {item.title}
                      </span>
                    </NavLink>
                  </li>
                )
              } else {
                return null
              }
            })}
          </ul>
        </nav>
      </motion.div>
    </div>
  )
}

export default Sidebar
